﻿var alert = require('./alert');
module.exports = san.defineComponent({
    template: require('../views/qjzxAsk.html'),
    initData: function () {
        return {
            askType: '',
            answerId: '',
            erweimaSrc: '',
            dataList: [],
            qustionList: [],
            cid: '',
            qType: '',
            params: {
                yourSex: '',
                part1: '',
                part2: '',
                part3: '',
                part4: '',
                part5: '',
                part6: '',
                part7: '',
                part8: '',
                part9: '',
                event1: '',
                event2: '',
                event3: ''
            },
            answerNum: 0,//是否全部选择完成
            loading: false,
            showCompany: false
        };
    },
    components: {
        'Alert': alert
    },
    created: function () {

    },
    showCompany: function () {
        this.data.set('showCompany', true);
    },
    getQType: function (obj) {
        var params = obj;
        this.data.set('loading', true);
        this.data.set('qType', params.id);
        this.data.set('askType', params.t);
        this.reset();
        this.getBgzx();
    },
    getBgzx: function () {
        this.data.set('dataList', []);
        var me = this;
        $.ajax({
            url: window.Apipath.getBgzx(me.data.get('askType')),
            // type:"post",
            dataType: 'json',
            success: function (resp) {
                for (var list in resp) {
                    if (me.data.get('qType') == resp[list].cid) {
                        me.data.set('dataList', resp[list].childrenList);
                    }
                }
                me.getTypeBgzx();
            },
            error: function (err) {

            }
        });
    },
    getTypeBgzx: function () {
        this.data.set('qustionList', []);
        var me = this;
        $.ajax({
            url: window.Apipath.getBgzx(),
            // type:"post",
            dataType: 'json',
            success: function (resp) {
                var qustionList = [];
                for (var list in resp) {
                    if (me.data.get('qType') == resp[list].id) {
                        qustionList.push(resp[list]);
                    }
                }
                me.data.set('qustionList', qustionList);
                me.data.set('cid', qustionList[0].cid);
                me.data.set('loading', false);
            },
            error: function (err) {

            }
        });
    },
    setAnswer: function () {
        this.data.set('answerId', '00001');
    },
    selectClick: function (t, id, it, sort, c) {
        var ifReturn = false;
        var me = this;
        if (!!it.checked && !it.other) {
            return;
        }
        me.data.set('cid', id);
        if (!!it.yourSex) {
            me.data.set('params.yourSex', it.yourSex);
            if (me.data.get('cid') != "201") {
                switch (me.data.get('params.yourSex')) {
                    case 1: me.data.set('params.part1', "你"); me.data.set('params.part2', "女方"); break;
                    case 2: me.data.set('params.part1', "你"); me.data.set('params.part2', "男方"); break;
                }
            } else {
                switch (me.data.get('params.yourSex')) {
                    case 1: me.data.set('params.part1', "你"); me.data.set('params.part2', "女方"); break;
                    case 2: me.data.set('params.part1', "男方"); me.data.set('params.part2', "你"); break;
                }
            }
        }
        if (!!it.answerId) {
            if (it.answerId !== "00000") {
                me.data.set('answerId', it.answerId);
            } else {
                var ifChecked = false;
                for (var r in t.answerList) {
                    if (!!t.answerList[r].checked) {
                        ifChecked = true;
                    }
                }
                if (!ifChecked) {
                    me.data.set('answerNum', me.data.get('answerNum') + 1);
                }
            }
        } else {
            me.data.set('answerId', '');
        }
        switch (parseInt(this.data.get('askType'))) {
            case 2:
                if (t.id == "20109" && it.value == 1) {
                    switch (me.data.get('params.yourSex')) {
                        case 1: me.data.set('params.part3', "女方"); me.data.set('params.part4', "你"); break;
                        case 2: me.data.set('params.part3', "男方"); me.data.set('params.part4', "你"); break;
                    }
                }
                if (t.id == "20109" && it.value == 2) {
                    switch (me.data.get('params.yourSex')) {
                        case 1: me.data.set('params.part3', "你"); me.data.set('params.part4', "女方"); break;
                        case 2: me.data.set('params.part3', "你"); me.data.set('params.part4', "男方"); break;
                    }
                }
                if (t.id == "20114" && it.value == 1) {
                    switch (me.data.get('params.yourSex')) {
                        case 1: me.data.set('params.part5', "你"); me.data.set('params.part6', "女方"); break;
                        case 2: me.data.set('params.part5', "你"); me.data.set('params.part6', "男方"); break;
                    }
                }
                if (t.id == "20114" && it.value == 2) {
                    switch (me.data.get('params.yourSex')) {
                        case 1: me.data.set('params.part5', "女方"); me.data.set('params.part6', "你"); break;
                        case 2: me.data.set('params.part5', "男方"); me.data.set('params.part6', "你"); break;
                    }
                }
                if (t.id == "20203" && it.value == 1) {
                    switch (me.data.get('params.yourSex')) {
                        case 1: me.data.set('params.part3', "你"); me.data.set('params.part4', "女方"); break;
                        case 2: me.data.set('params.part3', "你"); me.data.set('params.part4', "男方"); break;
                    }
                }
                if (t.id == "20203" && it.value == 2) {
                    switch (me.data.get('params.yourSex')) {
                        case 1: me.data.set('params.part3', "女方"); me.data.set('params.part4', "你"); break;
                        case 2: me.data.set('params.part3', "男方"); me.data.set('params.part4', "你"); break;
                    }
                }
                if (t.id == "20204" && it.value == 2) {
                    switch (me.data.get('params.yourSex')) {
                        case 1: me.data.set('params.part3', "你"); me.data.set('params.part4', "女方"); break;
                        case 2: me.data.set('params.part3', "你"); me.data.set('params.part4', "男方"); break;
                    }
                }
                if (t.id == "20204" && it.value == 3) {
                    switch (me.data.get('params.yourSex')) {
                        case 1: me.data.set('params.part3', "女方"); me.data.set('params.part4', "你"); break;
                        case 2: me.data.set('params.part3', "男方"); me.data.set('params.part4', "你"); break;
                    }
                }
                if (t.id == "20205" && it.value == 3) {
                    switch (me.data.get('params.yourSex')) {
                        case 1: me.data.set('params.part3', "女方"); me.data.set('params.part4', "你"); break;
                        case 2: me.data.set('params.part3', "男方"); me.data.set('params.part4', "你"); break;
                    }
                }
                if (t.id == "20205" && it.value == 4) {
                    switch (me.data.get('params.yourSex')) {
                        case 1: me.data.set('params.part3', "你"); me.data.set('params.part4', "女方"); break;
                        case 2: me.data.set('params.part3', "你"); me.data.set('params.part4', "男方"); break;
                    }
                }
                if (t.id == "20302" && it.value == 1) {
                    me.data.set('params.part7', "男");
                }
                if (t.id == "20302" && it.value == 2) {
                    me.data.set('params.part7', "女");
                }
                if (t.id == "20307" && it.value == 1) {
                    switch (me.data.get('params.yourSex')) {
                        case 1: me.data.set('params.part3', "你"); me.data.set('params.part4', "女方"); break;
                        case 2: me.data.set('params.part3', "男方"); me.data.set('params.part4', "你"); break;
                    }
                }
                if (t.id == "20307" && it.value == 2) {
                    switch (me.data.get('params.yourSex')) {
                        case 1: me.data.set('params.part3', "女方"); me.data.set('params.part4', "你"); break;
                        case 2: me.data.set('params.part3', "你"); me.data.set('params.part4', "男方"); break;
                    }
                }
                if (t.id == "20305" && it.value == 1) {
                    me.data.set('params.part5', "你");
                }
                if (t.id == "20305" && it.value == 2) {
                    switch (me.data.get('params.yourSex')) {
                        case 1: me.data.set('params.part5', "女方"); break;
                        case 2: me.data.set('params.part5', "男方"); break;
                    }
                }
                if (t.id == "204") {
                    me.data.set('params.part4', it.value);
                }
                if (t.id == "20413" && it.value == 1) {
                    me.data.set('params.part1', "是");
                    me.data.set('params.part2', "所在集体所有制组织");
                }
                if (t.id == "20413" && it.value == 2) {
                    me.data.set('params.part1', "不是");
                    me.data.set('params.part2', "国家");
                }
                if (t.id == "20415" && (it.value == 1 || it.value == 2)) {
                    me.data.set('params.part5', "无效");
                }
                if (t.id == "20415" && it.value == 3) {
                    me.data.set('params.part5', "不能执行");
                }
                if (t.id == "20416") {
                    switch (it.value) {
                        case 1: me.data.set('params.part3', "自书遗嘱"); break;
                        case 2: me.data.set('params.part3', "代书遗嘱"); break;
                        case 3: me.data.set('params.part3', "录音遗嘱"); break;
                        case 4: me.data.set('params.part3', "口头遗嘱"); break;
                    }
                }
                if (t.id == "20504" && it.value == 2) {
                    me.data.set('params.part1', "表示不认可");
                }
                if (t.id == "20504" && it.value == 3) {
                    me.data.set('params.part1', "对此不知情");
                }
                break;
            case 3:
                if (t.id == "30705") {
                    me.data.set('params.part1', it.label);
                }
                break;
            case 4:
                if (t.id == "40101" && it.value == 1) {
                    me.data.set('params.part1', "财产");
                    // me.data.set('params.part2', "承担修理、更换、退货以及相应财产损失赔偿责任。");
                    me.data.set('params.part3', "");
                }
                if (t.id == "40101" && it.value == 2) {
                    me.data.set('params.part1', "人身");
                    // me.data.set('params.part2', "承担修理、更换、退货以及相应的人身损害赔偿责任，可以要求赔偿医疗费、治疗期间的护理费、因误工减少的收入等费用；造成残疾的，还应当支付残疾者生活自助具费、生活补助费、残疾赔偿金以及由其扶养的人所必需的生活费等费用；造成受害人死亡的，并应当支付丧葬费、死亡赔偿金以及由死者生前扶养的人所必需的生活费等费用。");
                    me.data.set('params.part3', "造成了人身损害的，还应注意保存病历、医生诊断证明、治疗费用发票、专家鉴定等证据。");
                }
                if (t.id == "40102" && it.value == 1) {
                    me.data.set('params.part1', "财产");
                    // me.data.set('params.part2', "承担修理、更换、退货以及相应财产损失赔偿责任。");
                    me.data.set('params.part3', "");
                }
                if (t.id == "40102" && it.value == 2) {
                    me.data.set('params.part1', "人身");
                    // me.data.set('params.part2', "承担修理、更换、退货以及相应的人身损害赔偿责任，可以要求赔偿医疗费、治疗期间的护理费、因误工减少的收入等费用；造成残疾的，还应当支付残疾者生活自助具费、生活补助费、残疾赔偿金以及由其扶养的人所必需的生活费等费用；造成受害人死亡的，并应当支付丧葬费、死亡赔偿金以及由死者生前扶养的人所必需的生活费等费用。");
                    me.data.set('params.part3', "造成了人身损害的，还应注意保存病历、医生诊断证明、治疗费用发票、专家鉴定等证据。");
                }
                if (t.id == "40103" && it.value == 1) {
                    me.data.set('params.part1', "财产");
                    // me.data.set('params.part2', "承担修理、更换、退货以及相应财产损失赔偿责任。");
                    me.data.set('params.part3', "");
                }
                if (t.id == "40103" && it.value == 2) {
                    me.data.set('params.part1', "人身");
                    // me.data.set('params.part2', "承担修理、更换、退货以及相应的人身损害赔偿责任，可以要求赔偿医疗费、治疗期间的护理费、因误工减少的收入等费用；造成残疾的，还应当支付残疾者生活自助具费、生活补助费、残疾赔偿金以及由其扶养的人所必需的生活费等费用；造成受害人死亡的，并应当支付丧葬费、死亡赔偿金以及由死者生前扶养的人所必需的生活费等费用。");
                    me.data.set('params.part3', "造成了人身损害的，还应注意保存病历、医生诊断证明、治疗费用发票、专家鉴定等证据。");
                }
                if (t.id == "40105" || t.id == "40109" || t.id == "40113") {
                    let typecontent = '' 
                    let content = me.data.get('params.part1')
                    if(t.id == "40105"){
                      typecontent = '食品或者药品'
                    }
                    if(t.id == "40109"){
                      typecontent = '产品'
                    }
                    if(t.id == "40113"){
                      typecontent = '赠品'
                    }
                    if(it.value == 1){                        
                        me.data.set('params.part2',  content == "财产" ? "承担财产损失赔偿责任，包括缺陷" + typecontent + "本身及以外其他财产损失。" : '承担人身损害赔偿责任，可以要求赔偿医疗费、治疗期间的护理费、因误工减少的收入等费用；造成残疾的，还应当支付残疾者生活自助具费、生活补助费、残疾赔偿金以及由其扶养的人所必需的生活费等费用；造成受害人死亡的，并应当支付丧葬费、死亡赔偿金以及由死者生前扶养的人所必需的生活费等费用。');
                    }else{
                        me.data.set('params.part2',  content == "财产" ? "承担修理、更换、退货以及相应财产损失赔偿责任。": '承担修理、更换、退货以及相应的人身损害赔偿责任，可以要求赔偿医疗费、治疗期间的护理费、因误工减少的收入等费用；造成残疾的，还应当支付残疾者生活自助具费、生活补助费、残疾赔偿金以及由其扶养的人所必需的生活费等费用；造成受害人死亡的，并应当支付丧葬费、死亡赔偿金以及由死者生前扶养的人所必需的生活费等费用。');
                    }
                  }
                break;
            case 6:
                if (t.id == "603") {
                    me.data.set('params.part9', it.label);
                }
                if (t.id == "60201" && it.value == 1) {
                    me.data.set('params.part1', "开发商");
                }
                if (t.id == "60201" && it.value == 2) {
                    me.data.set('params.part1', "卖房人");
                }
                if (t.id == "60107" && it.value == 1) {
                    me.data.set('params.part3', "定金");
                }
                if (t.id == "60107" && it.value == 2) {
                    me.data.set('params.part3', "订金");
                }
                if (t.id == "60204") {
                    me.data.set('params.part2', it.label);
                }
                if (t.id == "60207") {
                    me.data.set('params.part3', it.label);
                }
                if (t.id == "60307" && it.value == 1) {
                    me.data.set('params.part1', "有约定");
                }
                if ((t.id == "60304" || t.id == "60308") && it.value == 2) {
                    me.data.set('params.part1', "没有约定");
                }
                if ((t.id == "60404" || t.id == "60403") && it.value == 1) {
                    me.data.set('params.part1', "约定了");
                }
                if ((t.id == "60404" || t.id == "60403") && it.value == 2) {
                    me.data.set('params.part1', "没有约定");
                }
                if (t.id == "60501") {
                    if (it.value == 1) {
                        me.data.set('params.part1', "购房人");
                        me.data.set('params.part2', "你公司");
                        me.data.set('params.part3', "购房人");
                    } else {
                        me.data.set('params.part1', "开发商");
                        me.data.set('params.part2', "开发商");
                        me.data.set('params.part3', "你");
                    }
                }
                if (t.id == "60509") {
                    if (it.value == 1) {
                        me.data.set('params.part2', "你");
                        me.data.set('params.part3', "购房人");
                        me.data.set('params.part4', "交房");
                    } else {
                        me.data.set('params.part2', "二手房房主");
                        me.data.set('params.part3', "你");
                        me.data.set('params.part4', "收房");
                    }
                }
                break;
            case 7:
                if ((t.id == "70105") && it.value == 1) {
                    me.data.set('params.part1', "利息");
                    me.data.set('params.part2', "利息，但是主张的利息应不超过合同成立时一年期贷款市场报价利率四倍");
                    me.data.set('params.part3', "并支付约定的利息");
                }
                if ((t.id == "70105") && it.value == 2) {
                    if (me.data.get('params.part1') != "") {
                        me.data.set('params.part1', "利息和违约金");
                        me.data.set('params.part2', "利息和违约金，但是约定的利息和违约金不能超过合同成立时一年期贷款市场报价利率四倍计算所得的数额");
                        me.data.set('params.part3', "支付约定的利息并承担违约责任");
                    } else {
                        me.data.set('params.part1', "违约金");
                        me.data.set('params.part2', "违约金，违约金总额不能超过合同成立时一年期贷款市场报价利率四倍计算所得的数额");
                        me.data.set('params.part3', "并承担违约责任");
                    }
                }
                break;
            case 8:
                if ((t.id == "801") && it.value == 1) {
                    me.data.set('params.part1', "你");
                    me.data.set('params.part2', "卖方");
                    me.data.set('params.part3', "买方");
                    me.data.set('params.part6', "无权要求对方返还定金");
                    me.data.set('params.part7', "卖方");
                }
                if ((t.id == "801") && it.value == 2) {
                    me.data.set('params.part1', "买方");
                    me.data.set('params.part2', "你");
                    me.data.set('params.part3', "卖方");
                    me.data.set('params.part6', "必须双倍返还定金");
                    me.data.set('params.part7', "买方");
                }
                break;
            case 9:
                if (t.id == "90111" && it.value == 1) {
                    me.data.set('params.part1', "对发起人签订的合同予以确认");
                }
                if (t.id == "90111" && it.value == 2) {
                    me.data.set('params.part1', "公司已经实际享有合同权利或履行合同义务");
                }
                if (t.id == "90104" && it.value == 2) {
                    me.data.set('params.part1', "因重大误解订立的");
                }
                if (t.id == "90104" && it.value == 3) {
                    me.data.set('params.part1', "在订立合同时显失公平的");
                }
                if (t.id == "90104" && it.value == 4) {
                    me.data.set('params.part1', "一方以欺诈、胁迫的手段或者乘人之危，使对方在违背真实意思的情况下订立的");
                }
                if (t.id == "90102" && it.value == 2) {
                    me.data.set('params.part1', "以欺诈、胁迫手段订立合同，损害国家利益");
                }
                if (t.id == "90102" && it.value == 3) {
                    me.data.set('params.part1', "恶意串通，损害国家、集体或者第三人利益");
                }
                if (t.id == "90102" && it.value == 4) {
                    me.data.set('params.part1', "以合法形式掩盖非法目的");
                }
                if (t.id == "90102" && it.value == 5) {
                    me.data.set('params.part1', "损害社会公共利益");
                }
                if (t.id == "90102" && it.value == 6) {
                    me.data.set('params.part1', "违反法律、行政法规的强制性规定");
                }
                break;
        }
        if (!!it.other || it.type == "radio") {
            me.otherSelect(t, id, it, c);
        }

        var qustionList = me.data.get('qustionList');
        if (t.id == "20309") {
            var num1 = 0, num2 = 0, special = 0;
            for (var list in qustionList) {
                if (id === qustionList[list].cid) {
                    if (!!qustionList[list].childrenList) {
                        qustionList[list].childrenList.bClass.forEach(function (item) {
                            if (item.id == "20308") {
                                item.answerList.forEach(function (s) {
                                    if (!!s.checked && s.other > 1) {
                                        num1++;
                                    }
                                    if(!!s.checked && s.value == 5){
                                        special++;
                                    }
                                });
                            }
                            if (item.id == "20309") {
                                item.answerList.forEach(function (s) {
                                    if (!!s.checked && s.other > 1) {
                                        num2++;
                                    }
                                    if(!!s.checked && s.value == 5){
                                        special++;
                                    }
                                });
                            }
                        });
                    }
                    if (me.data.get('part7') == "男") {
                        num1++;
                    } else {
                        num2++;
                    }
                    if (special == 2) {
                        me.data.set('answerId', '20306');
                        it.answerId = "20306";
                        it.childId = "";
                    } else {
                        me.data.set('answerId', "");
                        it.answerId = "";
                        it.childId = "20313";
                    }
                }
            }
        }
        if (!!it.other) {
            for (var list in qustionList) {
                if (id === qustionList[list].cid) {
                    if (!!qustionList[list].childrenList) {
                        switch (c) {
                            case 2:
                                qustionList[list].childrenList.aClass.forEach(function (item) {
                                    if (item.id == t.id) {
                                        var num = 0;
                                        if (it.other > 1) {
                                            item.answerList.forEach(function (item2) {
                                                if (item2.checked) {
                                                    num++;
                                                }
                                            });
                                            if (num == 0 && !it.checked) {
                                                qustionList[list].childrenList.bClass = [];
                                                me.data.set('answerId', '');
                                                ifReturn = true;
                                            } else if (num == 1 && it.type == "radio") {
                                                qustionList[list].childrenList.bClass = [];
                                            }
                                        } else if (it.other === 1) {
                                            qustionList[list].childrenList.bClass = [];
                                        }
                                    }
                                });
                                break;
                            case 3:
                                if (qustionList[list].childrenList.bClass.length > 0) {
                                    qustionList[list].childrenList.bClass.forEach(function (item) {
                                        if (item.id == t.id) {
                                            var ifEmpty = false;
                                            var num = 0;
                                            if (it.other > 1) {
                                                item.answerList.forEach(function (item2) {
                                                    if (item2.checked) {
                                                        num++;
                                                    }
                                                });
                                                if (num == 0 && !it.checked) {
                                                    me.data.set('answerId', '');
                                                    ifEmpty = true;
                                                    ifReturn = true;
                                                } else if (num == 1 && it.type == "radio") {
                                                    ifEmpty = true;
                                                }
                                            } else if (it.other === 1) {
                                                ifEmpty = true;
                                            }
                                            if (ifEmpty) {
                                                if (sort < qustionList[list].childrenList.bClass.length) {
                                                    var length = qustionList[list].childrenList.bClass.length;
                                                    for (var i = length; i > sort; i--) {
                                                        qustionList[list].childrenList.bClass.splice(i - 1, 1);
                                                    }
                                                }
                                            }
                                        }
                                    })
                                }
                                break
                        }
                    }
                }
            }
        }
        if (ifReturn) {
            me.next(qustionList);
            return;
        }
        if ((!!it.childId || it.other) && !it.answerId) {
            me.searchQuestion(it, sort, c);
        } else if (!!it.answerId) {
            for (var q in qustionList) {
                if (!!qustionList[q].childrenList) {
                    switch (c) {
                        case 1:
                            var allUnCheck = true;
                            if (qustionList[q].cid == t.cid) {
                                qustionList[q].childrenList.aClass = [];
                                qustionList[q].childrenList.bClass = [];
                                for (var c in qustionList[q].answerList) {
                                    if (qustionList[q].answerList[c].checked) {
                                        allUnCheck = false;
                                        break;
                                    }
                                }
                                if (allUnCheck) {
                                    me.data.set('answerId', "");
                                }
                            }
                            break;
                        case 2:
                            qustionList[q].childrenList.bClass = [];
                            break;
                        case 3:
                            if (sort < qustionList[q].childrenList.bClass.length) {
                                var length = qustionList[q].childrenList.bClass.length;
                                for (var i = length; i > sort; i--) {
                                    qustionList[q].childrenList.bClass.splice(i - 1, 1);
                                }
                            }
                    }
                }
            }
        }
        me.next(JSON.stringify(qustionList));
        me.scrollToBottom();
    },
    next: function (list) {
        var me = this;
        let newList = typeof(list) == 'string' ? JSON.parse(list) : list
        san.nextTick(function () {
            me.data.set('qustionList', []);
            me.data.set('qustionList', newList);
        });
    },
    //选择其他，其它选项不选中
    otherSelect: function (t, id, it, c) {
        var qustionList = this.data.get('qustionList');
        var me = this;
        for (var list in qustionList) {
            if (id == qustionList[list].cid) {
                switch (c) {
                    case 1:
                        if (it.other == 1 || it.type == 'radio') {
                            qustionList[list].answerList.forEach(function (item2) {
                                if (item2.value != it.value) {
                                    item2.checked = false;
                                } else {
                                    item2.checked = true;
                                }
                            });
                        } else if (it.other > 1) {
                            qustionList[list].answerList.forEach(function (item2) {
                                if (item2.other != it.other) {
                                    item2.checked = false;
                                }
                            });
                            it.checked = !it.checked;
                        }
                        break;
                    case 2:
                        //在问题列表里寻找对应问题
                        if (!!qustionList[list].childrenList) {
                            qustionList[list].childrenList.aClass.forEach(function (item) {
                                //找到当前点击的问题
                                if (item.id == t.id) {
                                    if (it.other == 1 || it.type == 'radio') {
                                        item.answerList.forEach(function (item2) {
                                            if (item2.value != it.value) {
                                                item2.checked = false;
                                            } else {
                                                item2.checked = true;
                                            }
                                        });
                                        it.checked = true;
                                    } else if (it.other > 1) {
                                        item.answerList.forEach(function (item2) {
                                            if (item2.other !== it.other) {
                                                item2.checked = false;
                                            }
                                        });
                                        it.checked = !it.checked;
                                    }
                                }
                            });
                        }
                        break;
                    case 3:
                        if (!!qustionList[list].childrenList) {
                            qustionList[list].childrenList.bClass.forEach(function (item) {
                                //找到当前点击的问题
                                if (item.id == t.id) {
                                    if (it.other == 1 || it.type == 'radio') {
                                        item.answerList.forEach(function (item2) {
                                            if (item2.value != it.value) {
                                                item2.checked = false;
                                            } else {
                                                item2.checked = true;
                                            }
                                        });
                                    } else if (it.other > 1) {
                                        item.answerList.forEach(function (item2) {
                                            if (item2.other !== it.other) {
                                                item2.checked = false;
                                            }
                                        });
                                        it.checked = !it.checked;
                                    }
                                }
                            });
                        }
                        break;
                }

            }
        }
        me.next(JSON.stringify(qustionList));
    },
    searchQuestion: function (it, sort, ct) {
        var item2 = '';
        var me = this;
        var qustionList = me.data.get('qustionList');
        let _obj = JSON.stringify(this.data.get('dataList')),
            newDataList = JSON.parse(_obj);
        newDataList.forEach(function (item) {
            //在问题组里寻找对应的下一个问题
            if (item.id == it.childId) {
                for (var q in qustionList) {
                    if (qustionList[q].cid == me.data.get('cid')) {
                        item2 = item;
                        //判断题目的级
                        item2.question = item2.question.replace(/{part1}/g, me.data.get('params.part1'));
                        item2.question = item2.question.replace(/{part2}/g, me.data.get('params.part2'));
                        item2.question = item2.question.replace(/{part3}/g, me.data.get('params.part3'));
                        item2.question = item2.question.replace(/{part4}/g, me.data.get('params.part4'));
                        item2.answerList.forEach((c) =>{
                            c.label = c.label.replace(/{part2}/g, me.data.get('params.part2'));
                            c.label = c.label.replace(/{part3}/g, me.data.get('params.part3'));
                        });
                        if (!!qustionList[q].childrenList) {
                            switch (ct) {
                                case 1:
                                    //判断二级问题列表是否有问题
                                    if (qustionList[q].childrenList.aClass.length > 0) {
                                        //判断是否全部没有选中
                                        var allUnCheck = true;
                                        //判断是否选择重复的答案
                                        var ifRepeat = false;
                                        for (var c in qustionList[q].answerList) {
                                            if (qustionList[q].answerList[c].checked) {
                                                allUnCheck = false;
                                            }
                                        }
                                        //判断是否选择了已有的选项
                                        /*if(q.childrenList.aClass[0].id == it.childId){
                                          ifRepeat = true;
                                        }*/
                                        if (!!allUnCheck) {
                                            qustionList[q].childrenList.aClass = [];
                                            qustionList[q].childrenList.bClass = [];
                                            me.data.set('answerId', "");
                                        }
                                        if (!allUnCheck && !ifRepeat) {
                                            qustionList[q].childrenList.aClass = [];
                                            qustionList[q].childrenList.bClass = [];
                                            item2.sort = sort + 1;
                                            me.checkedFalse(item2);
                                            qustionList[q].childrenList.aClass.push(item2);
                                        }
                                    } else {
                                        me.checkedFalse(item2);
                                        qustionList[q].childrenList.aClass.push(item2);
                                    }
                                    break;
                                case 2:
                                    //判断三级问题列表是否有问题
                                    if (qustionList[q].childrenList.bClass.length > 0) {
                                        qustionList[q].childrenList.bClass = [];
                                        item2.sort = 1;
                                        me.checkedFalse(item2);
                                        qustionList[q].childrenList.bClass.push(item2);
                                    } else {
                                        item2.sort = 1;
                                        me.checkedFalse(item2);
                                        qustionList[q].childrenList.bClass.push(item2);
                                    }
                                    break;
                                case 3:
                                    //判断三级问题列表是否有问题
                                    if (qustionList[q].childrenList.bClass.length > 0) {
                                        var allUnCheck = true;
                                        var ifRepeat = false;
                                        for (var qus in qustionList[q].childrenList.bClass) {
                                            for (var c in qustionList[q].childrenList.bClass[qus].answerList) {
                                                if (qustionList[q].childrenList.bClass[qus].answerList[c].checked) {
                                                    allUnCheck = false;
                                                    break;
                                                }
                                            }
                                            //判断是否选择了已有的选项
                                            /*                        if(qustion.id == it.childId && !it.other){
                                                                      ifRepeat = true;
                                                                      return;
                                                                    }*/
                                        }
                                        if (!ifRepeat) {
                                            if (sort < qustionList[q].childrenList.bClass.length) {
                                                var length = qustionList[q].childrenList.bClass.length;
                                                for (var i = length; i > sort; i--) {
                                                    qustionList[q].childrenList.bClass.splice(i - 1, 1);
                                                }
                                            }
                                            if (!allUnCheck) {
                                                item2.sort = sort + 1;
                                                me.checkedFalse(item2);
                                                qustionList[q].childrenList.bClass.push(item2);
                                            }
                                        }
                                    } else {
                                        item2.sort = sort + 1;
                                        me.checkedFalse(item2);
                                        qustionList[q].childrenList.bClass.push(item2);
                                        break;
                                    }
                                    break;
                            }
                        }
                    }
                }
            }
        });
        me.next(JSON.stringify(qustionList));
    },
    scrollToBottom: function () {
        var me = this;
        san.nextTick(function () {
            me.dispatch('toScroll', me.ref('scroll').scrollHeight);
        })
    },
    checkedFalse: function (item) {
        item.answerList.forEach(function (t) {
            t.checked = false;
        })
    },
    switchShow: function (t) {
        t.isOpen = !t.isOpen;
        var me = this;
        san.nextTick(function () {
            me.dispatch('toScroll', me.ref('scroll').scrollHeight);
        });
    },
    init: function () {
        this.data.set('event1', "");
        this.data.set('event2', "");
        this.data.set('event3', "");
    },
    submit: function () {
        var me = this;
        me.modelSelect(me.data.get('askType'), me.data.get('qType'), "", "CREATE_CONSULT_WORD");
        if (!!me.data.get('answerId') && me.data.get('answerNum') >= me.data.get('qustionList').length - 1) {
            var ifReturn = false;
            me.init();
            var qustionList = me.data.get('qustionList');
            switch (me.data.get('askType')) {
                case "2":
                    var num1 = 0, num2 = 0, num3 = 0, num4 = 0;
                    for (var list = 0; list < qustionList.length; list++) {
                        if (qustionList[list].childrenList.bClass.length > 0) {
                            for (var it in qustionList[list].childrenList.bClass) {
                                if (qustionList[list].childrenList.bClass[it].id == "20115" || qustionList[list].childrenList.bClass[it].id == "20116") {
                                    for (var s in qustionList[list].childrenList.bClass[it].answerList) {
                                        if (!!qustionList[list].childrenList.bClass[it].answerList[s].checked && qustionList[list].childrenList.bClass[it].answerList[s].other > 1) {
                                            if (me.data.get('params.event2') != '') {
                                                me.data.set('params.event2', me.data.get('params.event2') + ",");
                                            }
                                            me.data.set('params.event2', me.data.get('params.event2') + qustionList[list].childrenList.bClass[it].answerList[s].label);
                                        }
                                    }
                                }
                                if (qustionList[list].childrenList.bClass[it].id == "20112") {
                                    for (var s in qustionList[list].childrenList.bClass[it].answerList) {
                                        if (!!qustionList[list].childrenList.bClass[it].answerList[s].checked) {
                                            me.data.set('params.event1', qustionList[list].childrenList.bClass[it].answerList[s].label);
                                        }
                                    }
                                }
                                if (qustionList[list].childrenList.bClass[it].id == "20304") {
                                    for (var s in qustionList[list].childrenList.bClass[it].answerList) {
                                        if (!!qustionList[list].childrenList.bClass[it].answerList[s].checked && qustionList[list].childrenList.bClass[it].answerList[s].other > 1) {
                                            if (me.data.get('params.event1') != '') {
                                                me.data.set('params.event1', me.data.get('params.event1') + ",");
                                            }
                                            me.data.set('params.event1', me.data.get('params.event1') + qustionList[list].childrenList.bClass[it].answerList[s].label);
                                        }
                                    }
                                }
                                if (qustionList[list].childrenList.bClass[it].id == "20415") {
                                    for (var s in qustionList[list].childrenList.bClass[it].answerList) {
                                        if (!!qustionList[list].childrenList.bClass[it].answerList[s].checked && qustionList[list].childrenList.bClass[it].answerList[s].other > 1) {
                                            if (me.data.get('params.event1') != '') {
                                                me.data.set('params.event1', me.data.get('params.event1') + ",");
                                            }
                                            me.data.set('params.event1', me.data.get('params.event1') + qustionList[list].childrenList.bClass[it].answerList[s].label);
                                        }
                                    }
                                }
                                if (me.data.get('answerId') == "00001") {
                                    if (qustionList[list].childrenList.bClass[it].id == "20418" || qustionList[list].childrenList.bClass[it].id == "20420" || qustionList[list].childrenList.bClass[it].id == "20423") {
                                        for (var s in qustionList[list].childrenList.bClass[it].answerList) {
                                            if (!!qustionList[list].childrenList.bClass[it].answerList[s].checked && qustionList[list].childrenList.bClass[it].answerList[s].other > 1) {
                                                num1++;
                                            }
                                        }
                                        if (num1 === qustionList[list].childrenList.bClass[it].answerList.length - 1) {
                                            me.data.set('answerId', "20412");
                                        } else {
                                            me.data.set('answerId', "20411");
                                        }
                                    }
                                }
                                if (qustionList[list].childrenList.bClass[it].id == "20308") {
                                    for (var s in qustionList[list].childrenList.bClass[it].answerList) {
                                        if (!!qustionList[list].childrenList.bClass[it].answerList[s].checked && qustionList[list].childrenList.bClass[it].answerList[s].other > 1) {
                                            if (me.data.get('params.event2') != '') {
                                                me.data.set('params.event2', me.data.get('params.event2') + ",");
                                            }
                                            me.data.set('params.event2', me.data.get('params.event2') + qustionList[list].childrenList.bClass[it].answerList[s].label);
                                            num1++;
                                        }
                                    }
                                }
                                if (qustionList[list].childrenList.bClass[it].id == "20309") {
                                    for (var s in qustionList[list].childrenList.bClass[it].answerList) {
                                        if (!!qustionList[list].childrenList.bClass[it].answerList[s].checked && qustionList[list].childrenList.bClass[it].answerList[s].other > 1) {
                                            if (me.data.get('params.event3') != '') {
                                                me.data.set('params.event3', me.data.get('params.event3') + ",");
                                            }
                                            me.data.set('params.event3', me.data.get('params.event3') + qustionList[list].childrenList.bClass[it].answerList[s].label);
                                            num2++;
                                        }
                                    }
                                    if (me.data.get('params.part7') == "男") {
                                        num1++;
                                    } else {
                                        num2++;
                                    }
                                    if (num1 > num2) {
                                        switch (me.data.get('params.yourSex')) {
                                            case 1: me.data.set('params.part6', "你"); break;
                                            case 2: me.data.set('params.part6', "男方"); break;
                                        }
                                    } else {
                                        switch (me.data.get('params.yourSex')) {
                                            case 1: me.data.set('params.part6', "女方"); break;
                                            case 2: me.data.set('params.part6', "你"); break;
                                        }
                                        me.data.set('params.event2', me.data.get('params.event3'));
                                    }
                                }
                                if (qustionList[list].childrenList.bClass[it].id == "20313" || qustionList[list].childrenList.bClass[it].id == "20314") {
                                    if (qustionList[list].childrenList.bClass[it].id == "20313") {
                                        for (var s in qustionList[list].childrenList.bClass[it].answerList) {
                                            if (!!qustionList[list].childrenList.bClass[it].answerList[s].checked && qustionList[list].childrenList.bClass[it].answerList[s].value == 1) {
                                                num3++;
                                            }
                                        }
                                    }
                                    if (qustionList[list].childrenList.bClass[it].id == "20314") {
                                        for (var s in qustionList[list].childrenList.bClass[it].answerList) {
                                            if (!!qustionList[list].childrenList.bClass[it].answerList[s].checked && qustionList[list].childrenList.bClass[it].answerList[s].value == 1) {
                                                num4++;
                                            }
                                        }
                                    }
                                    if (num3 == num4) {
                                        me.data.set('answerId', num3 && num4 ? "20306" :"20314");
                                    } else if (num3 > num4) {
                                        me.data.set('answerId', "20313");
                                        me.data.set('params.part8', "你");
                                    } else {
                                        me.data.set('answerId', "20313");
                                        me.data.set('params.part8', "对方");
                                    }
                                    if(it.id == "20610"){
                                        let num = 0;
                                        let arr = [];
                                        for(let a of it.answerList){
                                          if(a.checked){
                                            num ++;
                                            arr.push(a.value);
                                          }
                                        }
                                        if(num  > 1 && arr.toString() != "1,3" && arr.toString() != "2,4"){
                                           me.data.set('answerId', "20628");
                                        }
                                    }
                                    if(it.id == "20609"){
                                        let num = 0;
                                        let arr = [];
                                        for(let a of it.answerList){
                                            if(a.checked){
                                                num ++;
                                                arr.push(a.value);
                                            }
                                        }
                                        if(num  > 1 && arr.toString() != "1,3" && arr.toString() != "2,4"){
                                            me.data.set('answerId', "20633");
                                        }
                                    }
                                    if(it.id == "20109"){
                                        if(me.data.get('answerId')== "20105"){
                                            for(let s of it.answerList){
                                                if((!!s.checked && s.value == 1 && this.params.yourSex == 2) || (!!s.checked && s.value == 2 && this.params.yourSex == 1)){
                                                    me.data.set('answerId', "20105a");
                                                }
                                            }
                                        }
                                    }
                                    if(it.id == "20105"){
                                        if(me.data.get('answerId')== "20106"){
                                            for(let s of it.answerList){
                                                if(!!s.checked && s.value == 2){
                                                    me.data.set('answerId', "20106a");
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                    if (me.data.get('answerId') == "00201") {
                        if (me.data.get('params.part4') == 1) {
                            me.data.set('answerId', "20491");
                        } else if (me.data.get('params.part4') == 2) {
                            me.data.set('answerId', "20409");
                        }
                    }
                    break;
                case "3":
                    for (var list = 0; list < qustionList.length; list++) {
                        if (qustionList[list].childrenList.aClass.length > 0) {
                            for (var it in qustionList[list].childrenList.aClass) {
                                if (qustionList[list].childrenList.aClass[it].id == "30502") {
                                    for (var s in qustionList[list].childrenList.aClass[it].answerList) {
                                        if (!!qustionList[list].childrenList.aClass[it].answerList[s].checked && qustionList[list].childrenList.aClass[it].answerList[s].other > 1) {
                                            if (me.data.get('params.event1') != '') {
                                                me.data.set('params.event1', me.data.get('params.event1') + ",");
                                            }
                                            me.data.set('params.event1', me.data.get('params.event1') + qustionList[list].childrenList.aClass[it].answerList[s].label);
                                        }
                                    }
                                }
                            }
                        }
                        if (qustionList[list].childrenList.bClass.length > 0) {
                            for (var it in qustionList[list].childrenList.bClass) {
                                if (qustionList[list].childrenList.bClass[it].id == "30409") {
                                    for (var s in qustionList[list].childrenList.bClass[it].answerList) {
                                        if (!!qustionList[list].childrenList.bClass[it].answerList[s].checked && qustionList[list].childrenList.bClass[it].answerList[s].other > 1) {
                                            if (me.data.get('params.event1') != '') {
                                                me.data.set('params.event1', me.data.get('params.event1') + ",");
                                            }
                                            me.data.set('params.event1', me.data.get('params.event1') + qustionList[list].childrenList.bClass[it].answerList[s].label);
                                        }
                                    }
                                }
                            }
                        }
                    }
                    break;
                case "4":
                    for (var list in qustionList) {
                        if (qustionList[list].childrenList.bClass.length > 0) {
                            for (var it in qustionList[list].childrenList.bClass) {
                                if (qustionList[list].childrenList.bClass[it].id == "40104") {
                                    for (var s in qustionList[list].childrenList.bClass[it].answerList) {
                                        if (!!qustionList[list].childrenList.bClass[it].answerList[s].checked && qustionList[list].childrenList.bClass[it].answerList[s].value == 2) {
                                            if (me.data.get("answerId") == "40101") {
                                                me.data.set("answerId", "40103");
                                            } else if (me.data.get("answerId") == "40102") {
                                                me.data.set("answerId", "40104");
                                            } else if (me.data.get("answerId") == "40105") {
                                                me.data.set("answerId", "40106");
                                            }
                                        }
                                    }
                                }
                                if (qustionList[list].childrenList.bClass[it].id == "40108") {
                                    for (var s in qustionList[list].childrenList.bClass[it].answerList) {
                                        if (!!qustionList[list].childrenList.bClass[it].answerList[s].checked && qustionList[list].childrenList.bClass[it].answerList[s].value == 2) {
                                            if (me.data.get("answerId") == "40110") {
                                                me.data.set("answerId", "40112");
                                            } else if (me.data.get("answerId") == "40111") {
                                                me.data.set("answerId", "40113");
                                            } else if (me.data.get("answerId") == "40114") {
                                                me.data.set("answerId", "40115");
                                            }
                                        }
                                    }
                                }
                                if (qustionList[list].childrenList.bClass[it].id == "40112") {
                                    for (var s in qustionList[list].childrenList.bClass[it].answerList) {
                                        if (!!qustionList[list].childrenList.bClass[it].answerList[s].checked && s.value == 2) {
                                            if (me.data.get("answerId") == "40119") {
                                                me.data.set("answerId", "40121");
                                            } else if (me.data.get("answerId") == "40120") {
                                                me.data.set("answerId", "40122");
                                            } else if (me.data.get("answerId") == "40123") {
                                                me.data.set("answerId", "40124");
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                    break;
                case "6":
                    for (var list = 0; list < qustionList.length; list++) {
                        if (qustionList[list].childrenList.bClass.length > 0) {
                            qustionList[list].childrenList.bClass.forEach(function (item) {
                                if (item.id == "60399") {
                                    var a = 0, b = 0, c = 0, d = 0;
                                    for (var answer = 0; answer < item.answerList.length; answer++) {
                                        var reg = /^(([0-9]+\.[0-9]*[1-9][0-9]*)|([0-9]*[1-9][0-9]*\.[0-9]+)|([0-9]*[1-9][0-9]*))$/;
                                        if (item.answerList[answer].value === '') {
                                            /*                                            this.$vux.toast.show({
                                                                                            type: 'text',
                                                                                            text: '请确保问题选择完毕'
                                                                                        });*/
                                            me.data.set('showAlert', false);
                                            me.dispatch('showAlert', { title: '提示', msg: "请确保问题选择完毕" });
                                            ifReturn = true;
                                            break;
                                        }
                                        if (reg.test(item.answerList[answer].value)) {
                                            if (item.answerList[answer].answerId == "00601") {
                                                a = item.answerList[answer].value;
                                                me.data.set('params.part2', a);
                                            }
                                            if (item.answerList[answer].answerId == "00602") {
                                                b = item.answerList[answer].value;
                                                me.data.set('params.part3', b);
                                            }
                                            if (item.answerList[answer].answerId == "00603") {
                                                c = item.answerList[answer].value;
                                                me.data.set('params.part4', c);
                                            }
                                        } else {
                                            /*                                            this.$vux.toast.show({
                                                                                            type: 'text',
                                                                                            text: '只能输入数字'
                                                                                        });*/
                                            me.data.set('showAlert', false);
                                            me.dispatch('showAlert', { title: '提示', msg: "只能输入数字" });
                                            ifReturn = true;
                                            break;
                                        }
                                    }
                                    d = parseFloat((b - a) / a * 100).toFixed(2);
                                    me.data.set('params.part5', Math.abs(b - a));
                                    me.data.set('params.part5', parseFloat(me.data.get('params.part5')).toFixed(2));
                                    me.data.set('params.part6', Math.abs(d));
                                    if (me.data.get('params.part1') == "有约定") {
                                        if (d > 3) {
                                            me.data.set('params.event1', parseFloat(a * 0.03 * c).toFixed(2));
                                            me.data.set('params.event2', parseFloat(a * 0.03).toFixed(2));
                                            me.data.set('params.event3', parseFloat((b - a) - a * 0.03).toFixed(2));
                                            me.data.set('params.part7', parseFloat(((b - a) - a * 0.03) * c * 2).toFixed(2));
                                            me.data.set('answerId', "60307");
                                        }
                                        if (d <= 0 && d > 3) {
                                            me.data.set('params.event1', parseFloat(a * 0.03 * c).toFixed(2));
                                            me.data.set('params.event2', parseFloat(a * 0.03).toFixed(2));
                                            me.data.set('params.event3', parseFloat((a - b) - a * 0.03).toFixed(2));
                                            me.data.set('params.part7', parseFloat(((a - b) - a * 0.03) * c * 2).toFixed(2));
                                            me.data.set('answerId', "60309");
                                        }
                                        if (d > 0 && d <= 3) {
                                            me.data.set('params.event1', parseFloat((b - a) * c).toFixed(2));
                                            me.data.set('answerId', "60311");
                                        }
                                        if (d <= -3) {
                                            me.data.set('params.event1', parseFloat(a * 0.03 * c).toFixed(2));
                                            me.data.set('params.event2', parseFloat(a * 0.03).toFixed(2));
                                            me.data.set('params.event3', parseFloat((a - b) - a * 0.03).toFixed(2));
                                            me.data.set('params.part7', parseFloat(((a - b) - a * 0.03) * c * 2).toFixed(2));
                                            me.data.set('params.part8', parseFloat(Number(me.data.get('params.event1')) + Number(me.data.get('params.part7'))).toFixed(2));
                                            me.data.set('answerId', "60313");
                                        }
                                    } else if (me.data.get('params.part1') == "没有约定") {
                                        if (d > 3) {
                                            me.data.set('params.event1', parseFloat(a * 0.03 * c).toFixed(2));
                                            me.data.set('params.event2', parseFloat(a * 0.03).toFixed(2));
                                            me.data.set('params.event3', parseFloat((b - a) - a * 0.03).toFixed(2));
                                            me.data.set('params.part7', parseFloat(((b - a) - a * 0.03) * c * 2).toFixed(2));
                                            me.data.set('answerId', "60308");
                                        }
                                        if (d <= 0 && d > -3) {
                                            me.data.set('params.event1', parseFloat((a - b) * c).toFixed(2));
                                            me.data.set('answerId', "60310");
                                        }
                                        if (d > 0 && d <= 3) {
                                            me.data.set('params.event1', parseFloat((b - a) * c).toFixed(2));
                                            me.data.set('answerId', "60312");
                                        }
                                        if (d <= -3) {
                                            me.data.set('params.event1', parseFloat(a * 0.03 * c).toFixed(2));
                                            me.data.set('params.event2', parseFloat(a * 0.03).toFixed(2));
                                            me.data.set('params.event3', parseFloat((a - b) - a * 0.03).toFixed(2));
                                            me.data.set('params.part7', parseFloat(((a - b) - a * 0.03) * c * 2).toFixed(2));
                                            me.data.set('params.part8', parseFloat(Number(me.data.get('params.event1')) + Number(me.data.get('params.part7'))).toFixed(2));
                                            me.data.set('answerId', "60314");
                                        }
                                    }
                                }
                                if (me.data.get('answerId') == "00643") {
                                    if (me.data.get('params.part1') == "约定了") {
                                        me.data.set('answerId', "60403");
                                    } else if (me.data.get('params.part1') == "没有约定") {
                                        me.data.set('answerId', "60404");
                                    }
                                }
                                if (me.data.get('answerId') == "00644") {
                                    if (me.data.get('params.part1') == "约定了") {
                                        me.data.set('answerId', "60409");
                                    } else if (me.data.get('params.part1') == "没有约定") {
                                        me.data.set('answerId', "60410");
                                        me.answerId = "60410";
                                    }
                                }
                            })
                        }
                    }
                    if (ifReturn) {
                        return;
                    }
                    break;
                case "8":
                    if(me.data.get('answerId') == "80101"){
                        if(me.data.get('params.part3') == "卖方"){
                            me.data.set('answerId', "80101a")
                        }
                    }
                    for (var list = 0; list < qustionList.length; list++) {
                        if (qustionList[list].childrenList.aClass.length > 0) {
                            for (var it in qustionList[list].childrenList.aClass) {
                                if (qustionList[list].childrenList.aClass[it].id == "80101" || qustionList[list].childrenList.aClass[it].id == "80102") {
                                    for (var s in qustionList[list].childrenList.aClass[it].answerList) {
                                        if (!!qustionList[list].childrenList.aClass[it].answerList[s].checked && qustionList[list].childrenList.aClass[it].answerList[s].other > 1) {
                                            if (me.data.get('params.part3') != '') {
                                                me.data.set('params.part3', me.data.get('params.part3') + ",");
                                            }
                                            me.data.set('params.part3', me.data.get('params.part3') + qustionList[list].childrenList.aClass[it].answerList[s].label);
                                        }
                                    }
                                }
                            }
                        }
                        if (qustionList[list].childrenList.bClass.length > 0) {
                            for (var it in qustionList[list].childrenList.bClass) {
                                if (qustionList[list].childrenList.bClass[it].id == "80103" || qustionList[list].childrenList.bClass[it].id == "80104") {
                                    for (var s in qustionList[list].childrenList.bClass[it].answerList) {
                                        if (!!qustionList[list].childrenList.bClass[it].answerList[s].checked && qustionList[list].childrenList.bClass[it].answerList[s].other > 1) {
                                            if (me.data.get('params.part4') != '') {
                                                me.data.set('params.part4', me.data.get('params.part4') + "；");
                                            }
                                            me.data.set('params.part4', me.data.get('params.part4') + qustionList[list].childrenList.bClass[it].answerList[s].label);
                                        }
                                    }
                                }
                                if (qustionList[list].childrenList.bClass[it].id == "80105" || qustionList[list].childrenList.bClass[it].id == "80106") {
                                    for (var s in qustionList[list].childrenList.bClass[it].answerList) {
                                        if (!!qustionList[list].childrenList.bClass[it].answerList[s].checked && qustionList[list].childrenList.bClass[it].answerList[s].other > 1) {
                                            if (me.data.get('params.part5') != '') {
                                                me.data.set('params.part5', me.data.get('params.part5') + "；");
                                            }
                                            me.data.set('params.part5', me.data.get('params.part5') + qustionList[list].childrenList.bClass[it].answerList[s].label);
                                        }
                                    }
                                }
                                if (qustionList[list].childrenList.bClass[it].id == "80116") {
                                    for (var s in qustionList[list].childrenList.bClass[it].answerList) {
                                        if (!!qustionList[list].childrenList.bClass[it].answerList[s].checked && qustionList[list].childrenList.bClass[it].answerList[s].other > 1) {
                                            if (me.data.get('params.event2') != '') {
                                                me.data.set('params.event2', me.data.get('params.event2') + "；");
                                            }
                                            if (qustionList[list].childrenList.bClass[it].answerList[s].value == 1) {
                                                me.data.set('params.event2', me.data.get('params.event2') + "按约定补足货物数量");
                                            }
                                            if (qustionList[list].childrenList.bClass[it].answerList[s].value == 2) {
                                                me.data.set('params.event2', me.data.get('params.event2') + "对质量不合格的货物进行修理或退换");
                                            }
                                            if (qustionList[list].childrenList.bClass[it].answerList[s].value == 3) {
                                                me.data.set('params.event2', me.data.get('params.event2') + "赔偿因迟延履行给你造成的实际损失");
                                            }
                                            if (me.data.get('params.part8') != '') {
                                                me.data.set('params.part8', me.data.get('params.part8') + "；");
                                            }
                                            me.data.set('params.part8', me.data.get('params.part8') + qustionList[list].childrenList.bClass[it].answerList[s].label);
                                        }
                                    }
                                }
                            }
                        }
                    }
                    break;
                case "9":
                    var checked = 1;
                    for (var list in qustionList) {
                        if (qustionList[list].childrenList.bClass.length > 0) {
                            for (var itt in qustionList[list].childrenList.bClass) {
                                var it = qustionList[list].childrenList.bClass[itt];
                                if (it.id == "90105") {
                                    for (var s in it.answerList) {
                                        if (!!it.answerList[s].checked && it.answerList[s].value == 2) {
                                            if (me.data.get('answerId') == "90106") me.data.set('answerId', '90106b');
                                            if (me.data.get('answerId') == "90107") me.data.set('answerId', '90107b');
                                            if (me.data.get('answerId') == "90112") me.data.set('answerId', '90112b');
                                            checked = 2;
                                        }
                                    }
                                }
                                if (it.id == "90106") {
                                    for (var s in it.answerList) {
                                        if (checked == 2 && !!it.answerList[s].checked && it.answerList[s].value == 1) {
                                            if (me.data.get('answerId') == "90108") me.data.set('answerId', '90108b');
                                            if (me.data.get('answerId') == "90109") me.data.set('answerId', '90109b');
                                            if (me.data.get('answerId') == "90110") me.data.set('answerId', '90110b');
                                            if (me.data.get('answerId') == "90111") me.data.set('answerId', '90111b');
                                        }
                                        if (checked == 2 && !!it.answerList[s].checked && it.answerList[s].value == 2) {
                                            if (me.data.get('answerId') == "90108") me.data.set('answerId', '90108b2');
                                            if (me.data.get('answerId') == "90109") me.data.set('answerId', '90109b2');
                                            if (me.data.get('answerId') == "90110") me.data.set('answerId', '90110b2');
                                            if (me.data.get('answerId') == "90111") me.data.set('answerId', '90111b2');
                                        }
                                    }
                                }
                            }
                        }
                    }
                    break;
            }
            var arr = this.setAnswerList();
            console.log(arr);
            me.dispatch('switchListType', { answerId: me.data.get('answerId'), askType: me.data.get('askType'), arr: JSON.stringify(arr), qType: me.data.get('qType'), part1: me.data.get('params.part1'), part2: me.data.get('params.part2'), part3: me.data.get('params.part3'), part4: me.data.get('params.part4'), part5: me.data.get('params.part5'), part6: me.data.get('params.part6'), part7: me.data.get('params.part7'), part8: me.data.get('params.part8'), part9: me.data.get('params.part9'), event1: me.data.get('params.event1'), event2: me.data.get('params.event2'), event3: me.data.get('params.event3') });
        } else {
            /*            this.$vux.toast.show({
                            type: 'text',
                            text: '请确保问题选择完毕'
                        })*/
            me.data.set('showAlert', false);
            me.dispatch('showAlert', { title: '提示', msg: "请确保问题选择完毕" });
        }

    },
    modelSelect: function (t, id, name, c) {
        var model, visitModel, visitModelName;
        switch (t) {
          case '1':
            model = "SCENE_CONSULT-JTSG";
            break;
          case '2':
              model = "SCENE_CONSULT-HYJT";
              break;
          case '3':
              model = "SCENE_CONSULT-LDZY";
              break;
          case '4':
              model = "SCENE_CONSULT-CPZL";
              break;
          case '5':
              model = "SCENE_CONSULT-QQJF";
              break;
          case '6':
              model = "SCENE_CONSULT-FCMM";
              break;
          case '7':
              model = "SCENE_CONSULT-MJJD";
              break;
          case '8':
              model = "SCENE_CONSULT-MMHT";
              break;
          case '9':
              model = "SCENE_CONSULT-GSCS";
              break;
          default:
              model = "SCENE_CONSULT";
        }
        switch (parseInt(id)) {
          case '101':
            visitModel = "SCENE_CONSULT-JTSG-SFPCZR";
            visitModelName = "情景咨询-交通事故-谁负赔偿责任";
            break;
          case '201':
              visitModel = "SCENE_CONSULT-HYJT-LHDTJ";
              visitModelName = "情景咨询-婚姻家庭-离婚的条件";
              break;
          case '202':
              visitModel = "SCENE_CONSULT-HYJT-LHZNFYF";
              visitModelName = "情景咨询-婚姻家庭-离婚子女抚养费";
              break;
          case '203':
              visitModel = "SCENE_CONSULT-HYJT-LHZNFYQ";
              visitModelName = "情景咨询-婚姻家庭-离婚子女抚养权";
              break;
          case '204':
              visitModel = "SCENE_CONSULT-HYJT-YCYSJC";
              visitModelName = "情景咨询-婚姻家庭-遗产由谁继承";
              break;
          case '205':
              visitModel = "SCENE_CONSULT-HYJT-FQGTZWRD";
              visitModelName = "情景咨询-婚姻家庭-夫妻共同债务认定";
              break;
          case '206':
              visitModel = "SCENE_CONSULT-HYJT-LHFCFG";
              visitModelName = "情景咨询-婚姻家庭-离婚房产分割";
              break;
          case '301':
              visitModel = "SCENE_CONSULT-LDZY-SBSLDGX";
              visitModelName = "情景咨询-劳动争议-是不是劳动关系";
              break;
          case '302':
              visitModel = "SCENE_CONSULT-LDZY-SBGZJF";
              visitModelName = "情景咨询-劳动争议-双倍工资纠纷";
              break;
          case '303':
              visitModel = "SCENE_CONSULT-LDZY-JJBCJF";
              visitModelName = "情景咨询-劳动争议-经济补偿纠纷";
              break;
          case '304':
              visitModel = "SCENE_CONSULT-LDZY-LDBCJF";
              visitModelName = "情景咨询-劳动争议-劳动报酬纠纷";
              break;
          case '305':
              visitModel = "SCENE_CONSULT-LDZY-GSRDZY";
              visitModelName = "情景咨询-劳动争议-工伤认定争议";
              break;
          case '306':
              visitModel = "SCENE_CONSULT-LDZY-SHBXJF";
              visitModelName = "情景咨询-劳动争议-社会保险纠纷";
              break;
          case '307':
              visitModel = "SCENE_CONSULT-LDZY-SYQJF";
              visitModelName = "情景咨询-劳动争议-试用期纠纷";
              break;
          case '308':
              visitModel = "SCENE_CONSULT-LDZY-WYJJF";
              visitModelName = "情景咨询-劳动争议-违约金纠纷";
              break;
          case '401':
              visitModel = "SCENE_CONSULT-CPZL-CPZL";
              visitModelName = "情景咨询-产品质量-产品质量";
              break;
          case '501':
              visitModel = "SCENE_CONSULT-QQJF-GYQQ";
              visitModelName = "情景咨询-侵权纠纷-雇佣侵权";
              break;
          case '601':
              visitModel = "SCENE_CONSULT-FCMM-RGSWT";
              visitModelName = "情景咨询-房产买卖-认购书问题";
              break;
          case '602':
              visitModel = "SCENE_CONSULT-FCMM-YFEMWT";
              visitModelName = "情景咨询-房产买卖-一房二卖问题";
              break;
          case '603':
              visitModel = "SCENE_CONSULT-FCMM-MJWC";
              visitModelName = "情景咨询-房产买卖-面积误差";
              break;
          case '604':
              visitModel = "SCENE_CONSULT-FCMM-YQBZ";
              visitModelName = "情景咨询-房产买卖-逾期办证";
              break;
          case '605':
              visitModel = "SCENE_CONSULT-FCMM-YQJF";
              visitModelName = "情景咨询-房产买卖-逾期交房";
              break;
          case '701':
              visitModel = "SCENE_CONSULT-MJJD-HKJF";
              visitModelName = "情景咨询-民间借贷-还款纠纷";
              break;
          case '801':
              visitModel = "SCENE_CONSULT-MMHT-HWMMHTJF";
              visitModelName = "情景咨询-买卖合同-货物买卖合同纠纷";
              break;
          case '901':
              visitModel = "SCENE_CONSULT-GSCS-GSSLGCZDMSZRCD";
              visitModelName = "情景咨询-公司财税-公司设立过程中的民事责任承担";
              break;
          default:
            visitModel = "";
            visitModelName = "";
        }
        window.NewLog._saveLog(model, "", visitModel, visitModelName, c);
    },
    reset: function () {
        var qustionList = this.data.get('qustionList');
        if (qustionList.length == 0) { return }
        for (var list in qustionList) {
            if (qustionList[list].childrenList) {
                qustionList[list].childrenList.aClass = [];
                qustionList[list].childrenList.bClass = [];
                for (var a in qustionList[list].answerList) {
                    qustionList[list].answerList[a].checked = false;
                }
            }
            this.data.set('answerId', "");
            this.data.set('answerNum', 0);
            this.data.set('qustionList[' + list + ']', []);
            this.data.set('qustionList[' + list + ']', qustionList[list]);
        }
    },
    setAnswerList: function () {
        var arr = {
            question_answer_json: [],
            content: []
        };
        var question = "";
        var answer = "";
        var qustionList = this.data.get('qustionList');
        for (var a in qustionList) {
            question = "";
            answer = "";
            qustionList[a].answerList.forEach(function (item, index) {
                if (item.checked) {
                    if (answer != "") {
                        answer += ",";
                    }
                    answer += item.label;
                }
            });
            arr.question_answer_json.push({ question: qustionList[a].question, answer: answer });
            qustionList[a].childrenList.aClass.forEach(function (item, index) {
                question = "";
                answer = "";
                item.answerList.forEach(function (item2, index2) {
                    if (item2.checked) {
                        if (answer != "") {
                            answer += ",";
                        }
                        answer += item2.label;
                    }
                });
                arr.question_answer_json.push({ question: item.question, answer: answer })
            });
            qustionList[a].childrenList.bClass.forEach(function (item, index) {
                question = "";
                answer = "";
                item.answerList.forEach(function (item2, index2) {
                    if (item2.type == "radio" || item2.type == "checkbox") {
                        if (item2.checked) {
                            if (answer != "") {
                                answer += ",";
                            }
                            answer += item2.label;
                        }
                    } else if (item2.type == "input") {
                        if (answer != "") {
                            answer += ",";
                        }
                        answer += item2.value;
                    }
                });
                arr.question_answer_json.push({ question: item.question, answer: answer })
            })
        }
        return arr;
    },
    messages: {

    }
});



//////////////////
// WEBPACK FOOTER
// ./src/components/qjzxAsk.js
// module id = 361
// module chunks = 1